module.exports = __webpack_public_path__ + "img/newClassic.5d0eeb43.png";